export default __webpack_public_path__ + "static/media/10.59a76ff3.jpeg";